import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function IssuanceBatchDetail() {
  const { id } = useParams();
  const [batch, setBatch] = useState(null);

  useEffect(() => {
    api.get(`/registry/issuance-batches/${id}`).then((r) => setBatch(r.data)).catch((err) => {
      toast.error(err.response?.data?.message || 'Failed to load issuance batch');
    });
  }, [id]);

  if (!batch) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div className="page-shell page-stack">
      <section className="surface-panel glow-surface" style={{ padding: '1.5rem' }}>
        <div className="section-tag">Issuance batch</div>
        <h1 className="section-title">{batch.project_name}</h1>
        <p className="section-copy">{batch.quantity} tCO2e · {batch.vintage} · {batch.status}</p>
        {batch.symbol && <Link to={`/markets/${batch.minted_token_class_id}`} className="btn btn-primary">Open token market</Link>}
      </section>
    </div>
  );
}
